import React from "react";
import { useTranslation } from "react-i18next";
import { VelavuSite } from "velavu-js-api";
import IconClose from "../../dynamicicons/icon-close";
import IconFilterList from "../../dynamicicons/icon-filter-list";
import IconSearch from "../../dynamicicons/icon-search";
import VelavuIconButton from "../../elements/velavu-icon-button";
import VelavuInput from "../../elements/velavu-input";
import * as styles from "./analytics-assets-navigation.module.scss";
import SelectorSite from "../shared/selector-site";
import whitelabel from "../../whitelabel";

export default function AnalyticsAssetsNavigation(props: {
	isSearching: boolean;
	openSearch?: VoidFunction;
	finishSearch?: VoidFunction;
	searchText: string;
	setSearchText: (searchText: string) => void;

	selectedSite?: VelavuSite | undefined;
	onOpenSiteSelector?: VoidFunction;
	selectedFloorID?: string | undefined;
	setSelectedFloorID?: (floorID: string | undefined) => void;

	isFiltering: boolean;
	isShowFilterMenu: boolean;
	onToggleFilterMenu: VoidFunction;
}) {
	const { t } = useTranslation();
	const {
		finishSearch,
		isFiltering,
		isSearching,
		onOpenSiteSelector,
		setSelectedFloorID,
		onToggleFilterMenu,
		openSearch,
		searchText,
		selectedFloorID,
		selectedSite,
		setSearchText,
		isShowFilterMenu,
	} = props;
	const filterColor = isFiltering
		? whitelabel.palette.primary900
		: whitelabel.palette.secondary700;

	return (
		<div className={styles.header}>
			{isSearching ? (
				<VelavuInput
					className={styles.search}
					leadingIcon={
						<IconSearch
							size={16}
							color={whitelabel.palette.secondary900}
						/>
					}
					trailingIcon={
						finishSearch !== undefined ? (
							<VelavuIconButton
								reallySmall
								onClick={finishSearch}
							>
								<IconClose
									size={16}
									color={whitelabel.palette.secondary500}
								/>
							</VelavuIconButton>
						) : undefined
					}
					placeholder={t("common.search_assets")}
					value={searchText}
					onChange={setSearchText}
					fullWidth
				/>
			) : (
				<>
					<SelectorSite
						style={{ flexGrow: 1, marginRight: 16 }}
						site={selectedSite}
						onClick={onOpenSiteSelector}
						selectedFloorID={selectedFloorID}
						onClickFloor={setSelectedFloorID}
					/>
					{openSearch !== undefined && (
						<VelavuIconButton
							style={{ marginRight: 8 }}
							onClick={openSearch}
						>
							<IconSearch
								color={whitelabel.palette.secondary700}
							/>
						</VelavuIconButton>
					)}
				</>
			)}
			<VelavuIconButton
				highlight={isFiltering}
				onClick={onToggleFilterMenu}
			>
				{isShowFilterMenu ? (
					<IconClose color={filterColor} />
				) : (
					<IconFilterList color={filterColor} />
				)}
			</VelavuIconButton>
		</div>
	);
}
